<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0"> 
      <!-- Brand logo-->
      <!-- <b-link class="brand-logo" :to="{name : 'login'}">
        <b-img :src="appLogoImage" :alt="'Logo ' + appName" width="40" height="40"/>
        <h2 class="brand-text text-primary m-auto pl-1">{{ appName }}</h2>
      </b-link> -->
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col lg="8" class="d-none d-lg-flex align-items-center p-5" >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img fluid :src="imgUrl" alt="Login" />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col lg="4" class="d-flex align-items-center auth-bg px-2 p-lg-5" >
        <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto" >
          <b-card-title class="mb-1 font-weight-bold" title-tag="h2" > ¡Bienvenido/a! </b-card-title>

          <!-- form -->
          <validation-observer ref="loginForm" #default="{invalid}" >
            <b-form class="auth-login-form mt-2" @submit.prevent="login" >
              <!-- email -->
              <b-form-group :label="$t('Email')" label-for="login-email" >
                <validation-provider #default="{ errors }" :name="$t('email')" vid="email" rules="required|email" >
                  <b-form-input id="login-email" v-model="userEmail" :state="errors.length > 0 ? false : null" name="login-email" :placeholder="$t('Email')" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">{{ $t("Password") }}</label>
                  <b-link :to="{name:'forgot-password'}">
                    <small>{{ $t("Forgot Password?") }}</small>
                  </b-link>
                </div>
                <validation-provider #default="{ errors }" :name="$t('password')" vid="password" rules="required" >
                  <b-input-group class="input-group-merge" :class="errors.length > 0 ? 'is-invalid':null" >
                    <b-form-input id="login-password" v-model="password" :state="errors.length > 0 ? false:null" class="form-control-merge" :type="passwordFieldType" name="login-password" :placeholder=" $t('Password')" />
                    <b-input-group-append is-text>
                      <feather-icon class="cursor-pointer" :icon="passwordToggleIcon" @click="togglePasswordVisibility" />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- checkbox -->
              <b-form-group>
                <b-form-checkbox id="remember-me" v-model="status" name="checkbox-1" > {{ $t("Remember Me") }} </b-form-checkbox>
              </b-form-group>

              <!-- submit buttons -->
              <b-button type="submit" variant="primary" block :disabled="invalid" > {{$t("Sign in")}} </b-button>
            </b-form>
          </validation-observer>

          <b-card-text class="text-center mt-2" v-if="register == 'true'">
            <span> {{ $t("New on our platform?")}} </span> <b-link :to="{name:'register'}"> <span>&nbsp;{{$t("Create an account")}}</span> </b-link>
          </b-card-text>

          <!-- divider -->
          <!-- <div class="divider my-2"> <div class="divider-text"> or </div> </div> -->

          <!-- social buttons -->
          <!-- <div class="auth-footer-btn d-flex justify-content-center">

            <b-button variant="facebook" href="javascript:void(0)" > <feather-icon icon="FacebookIcon" /> </b-button>
            <b-button variant="twitter" href="javascript:void(0)" > <feather-icon icon="TwitterIcon" /> </b-button>
            <b-button variant="google" href="javascript:void(0)" > <feather-icon icon="MailIcon" /> </b-button>
            <b-button variant="github" href="javascript:void(0)" > <feather-icon icon="GithubIcon" /> </b-button>

          </div> -->

        </b-col>
      </b-col>
    <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BFormCheckbox, BCardText, BCardTitle, BImg, BForm, BButton, BAlert, VBTooltip, } from 'bootstrap-vue'
import useJwt from '@/auth/jwt/useJwt'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { $themeConfig } from '@themeConfig'
import axios from '@axios'


export default {

  // DIRECTIVAS
  directives: { 'b-tooltip': VBTooltip, },

  // COMPONENTES
  components: { BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BFormCheckbox, BCardText, BCardTitle, BImg, BForm, BButton, BAlert, ValidationProvider, ValidationObserver, },

  // MIXINS
  mixins: [togglePasswordVisibility],

  // DATA
  data() {
    return {
      status: '',
      password: '',
      userEmail: '',
      sideImg: require('@/assets/images/pages/login.svg'),
      register: false,
      required,
      email,
    }
  },

  // VALOR COMPUTADOS
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/login-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },



  // MÉTODOS
  methods: {
    login() {
      this.$refs.loginForm.validate().then(success => {
        if (success) {
          useJwt
            .login({
              email: this.userEmail,
              password: this.password,
            })
            .then(response => {
              const { userData } = response.data
                useJwt.setToken(response.data.accessToken)
                // useJwt.setRefreshToken(response.data.refreshToken)
                localStorage.setItem('userData', JSON.stringify(userData))
                this.$ability.update(userData.ability)
                this.$router.replace({ name: 'home' })
            })
            .catch(error => {
              localStorage.removeItem('userData')
              localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName)
              this.$refs.loginForm.setErrors(error.response.data.error)
            })
        }
      })
    },
  },
  setup(){
    // const { appName, appLogoImage } = $themeConfig.app
    // return { appName, appLogoImage, }
  },
  created(){
    axios
        .post('/settings/public')
        .then(response => {
          this.register = response.data.public_register
        })
        .catch(error => {
          this.register = false
        })
  }
}
</script>

<style lang="scss">
@import '~@core/scss/vue/pages/page-auth.scss';
</style>
